/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cs-primary-tabs.department-tabs[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.nav-item.active[_ngcontent-%COMP%] > a.active[_ngcontent-%COMP%]:after{content:\"\";position:absolute;left:45%;bottom:-14px;border:7px solid transparent;border-top:7px solid #0f7bb6}.cs-secondary-tabs.department-tabs[_ngcontent-%COMP%]   ul.nav.nav-tabs[_ngcontent-%COMP%]{border-bottom:transparent!important;margin-top:-6px;z-index:1}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/admin.component.less.shim.ngstyle.js.pre-build-optimizer.js